export const TypeOfVisitor = ["Delivery", "Family & Friends", "Other"];
export default TypeOfVisitor;
